<template>
  <small-modal
    :fit-content="true"
    :show-close-button="false"
    class="filter-modal"
    @close="$emit('close-filter-modal')"
  >
    <div class="video-filter-container">
      <h1 class="filter">{{ $t("campaignManager.filter.filters") }}</h1>
      <span class="reset" @click="resetFilters">{{
        $t("campaignManager.filter.reset")
      }}</span>
      <form class="filter-wrapper">
        <!-- Tags -->
        <div>
          <label>
            <h2 class="filter-type-title">Tags</h2>
          </label>
          <v-select
            v-model="tagsSelectedFilters"
            class="dropdown tags-dropdown"
            :options="filteredTagsArray"
            label="name"
            multiple
            clearable
            :placeholder="placeholder"
            @input="applyTagFilter"
          />
        </div>

        <!-- Currently Published -->
        <div>
          <label>
            <h2 class="filter-type-title">
              {{ $t("create.step2.videoFilterModal.published") }}
            </h2>
          </label>
          <v-select
            v-model="selectedPublishedOption"
            class="dropdown"
            :options="publishedOptions"
            label="title"
            :reduce="(opt) => opt.value"
            clearable
            :placeholder="placeholder"
            @input="applyPublishedFilter"
          />
        </div>

        <!-- Products Tagged -->
        <div>
          <label>
            <h2 class="filter-type-title">
              {{ $t("create.step2.videoFilterModal.products") }}
            </h2>
          </label>
          <v-select
            v-model="selectedProductsOption"
            class="dropdown"
            :options="productsOptions"
            label="title"
            :reduce="(opt) => opt.value"
            clearable
            :placeholder="placeholder"
            @input="applyProductsTaggedFilter"
          />
        </div>
      </form>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import { mapGetters } from "vuex";

export default {
  name: "VideoFilterModal",
  components: { SmallModal },
  props: {
    initialTags: {
      type: Array,
      default: () => [],
    },
    initialPublished: {
      type: String,
      default: null,
    },
    initialProductsTagged: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // Tags: retain full tag objects
      tagsSelectedFilters: [...this.initialTags],
      // Published and Products: store value strings
      selectedPublishedOption: this.initialPublished,
      selectedProductsOption: this.initialProductsTagged,
      placeholder: this.$t("campaignManager.filter.select"),
      // Options definitions
      publishedOptions: [
        {
          value: "live",
          title: this.$t("create.step2.videoFilterModal.live"),
        },
        {
          value: "not_live",
          title: this.$t("create.step2.videoFilterModal.notLive"),
        },
      ],
      productsOptions: [
        {
          value: "have_products",
          title: this.$t("create.step2.videoFilterModal.haveProducts"),
        },
        {
          value: "have_not",
          title: this.$t("create.step2.videoFilterModal.noProducts"),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({ tagsArray: "tag/getTags" }),
    filteredTagsArray() {
      return this.tagsArray
        .filter((tag) => tag.type === "library")
        .map((tag) => ({ ...tag }));
    },
  },
  watch: {
    // Sync re-opened values
    initialTags(newTags) {
      this.tagsSelectedFilters = [...newTags];
    },
    initialPublished(newVal) {
      this.selectedPublishedOption = newVal;
    },
    initialProductsTagged(newVal) {
      this.selectedProductsOption = newVal;
    },
  },
  methods: {
    applyTagFilter(selection) {
      this.$emit("filter", { tags: selection });
    },
    applyPublishedFilter(value) {
      this.$emit("filter", { published: value });
    },
    applyProductsTaggedFilter(value) {
      this.$emit("filter", { productsTagged: value });
    },
    resetFilters() {
      this.tagsSelectedFilters = [];
      this.selectedPublishedOption = null;
      this.selectedProductsOption = null;
      this.$emit("reset");
    },
  },
};
</script>

<style lang="scss">
.filter-modal .small-modal.fit-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  top: 130px;
  left: 32%;
  transform: translate(0, 0);
  width: 210px;
  border: 1px solid rgba(196, 196, 196, 1);
}

.dropdown {
  .vs__dropdown-toggle {
    min-height: 48px;
  }
  .vs__search {
    font-family: Montserrat;
    color: $light-grey;
    font-size: 14px;
    font-weight: 400;
  }
  .vs__selected-options {
    flex-wrap: nowrap;
  }
  .vs__dropdown-option {
    padding-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vs__dropdown-menu {
    position: absolute !important;
  }
}
</style>

<style lang="scss" scoped>
.modal-background {
  background: transparent;
  width: 100% !important;
}

.filter {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: default;
  margin-bottom: 14px;
}
.reset {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: $light-grey;
  position: fixed;
  top: 16px;
  right: 16px;
  cursor: pointer;
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-type-title {
  margin-bottom: 8px;
}
</style>
